import { applyDecorators, HttpCode, HttpStatus, Post, Put, Type, UseInterceptors } from '@nestjs/common';
import {
  ApiConflictResponse,
  ApiForbiddenResponse,
  ApiInternalServerErrorResponse,
  ApiNoContentResponse,
  ApiNotFoundResponse,
  ApiOkResponse,
  ApiUnauthorizedResponse,
  ApiUnprocessableEntityResponse,
} from '@nestjs/swagger';

import { Roles } from '../../auth';
import { AutoReapInterceptor } from '../interceptors';

export const UpdateResponse = <T extends Type>(path: string | string[], type?: T | [T], roles?: string[], asPut = false) =>
  applyDecorators(
    ApiConflictResponse({ description: 'Conflict (409)' }),
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiNotFoundResponse({ description: 'Not Found (404)' }),
    type ? ApiOkResponse({ description: 'OK (200)', type }) : ApiNoContentResponse({ description: 'No Content (204)' }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    HttpCode(type ? HttpStatus.OK : HttpStatus.NO_CONTENT),
    asPut ? Put(path) : Post(path),
    Roles(roles),
    UseInterceptors(AutoReapInterceptor)
  );
